// Keep in mind the number contains unbreakable spaces!
export const SUPPORT_PHONE = '224 443 636' // The number contains non-breaking spaces. Keep it in mind when editing.
export const SUPPORT_PHONE2 = '728 133 133' // The number contains non-breaking spaces. Keep it in mind when editing.
export const CZECH_PHONE_PREFIX = '+420'

export const OTHER_COST_OF_LIVING_LIMIT = 5000

export const POLLING_DELAY_IN_MS = 5 * 1000
export const POOLING_DELAY_CLIENT_CHECK = 30 * 1000
export const CONTRACT_SPINNER_DELAY = 8 * 1000

export const MAX_UPLOAD_FILE_SIZE = 20 * 1024 * 1024

export const INACTIVITY_TIMEOUT_MIN = 25
export const LOGOUT_TIMEOUT_MIN = 5

export const INACTIVITY_TIMEOUT = INACTIVITY_TIMEOUT_MIN * 60 * 1000
export const LOGOUT_TIMEOUT = LOGOUT_TIMEOUT_MIN * 60 * 1000

export const IDENTITY_CARD = 'IDENTITY_CARD'
export const OTHER_IDENTITY_DOCUMENT = 'OTHER_IDENTITY_DOCUMENT'
export const ACKNOWLEDGMENT_OF_RECEIPT = 'ACKNOWLEDGMENT_OF_RECEIPT'

export const NOT_AVAILABLE = 'N/A'

// employmentType
export const SORT_TERM_JOB = '2'
